export default __webpack_public_path__ + "static/media/vendor_management.379480b9.xlsx";